import { jsx as i } from "react/jsx-runtime";
import { InlineSpinner as m } from "./InlineSpinner.js";
import { Alert as d } from "./Alert.js";
import { V as u } from "./ValidationErrors-5bae4ca7.js";
function y({ message: n }) {
  return n = n || "Carregando informações...", /* @__PURE__ */ i("div", { className: "py-2 text-sm text-gray-500", children: /* @__PURE__ */ i(m, { children: n }) });
}
function A({ error: n }) {
  return /* @__PURE__ */ i(
    d,
    {
      fullWidth: !0,
      title: "Ocorreu um erro ao buscar as informações",
      color: "danger",
      children: /* @__PURE__ */ i("pre", { className: "mt-8 whitespace-pre-line", children: JSON.stringify(n) })
    }
  );
}
function j() {
  return /* @__PURE__ */ i("div", { className: "py-2 text-sm text-gray-500", children: /* @__PURE__ */ i(m, { children: "Atualizando informações..." }) });
}
const N = ({
  graphQLErrors: n
}) => {
  if (!n || n.length === 0)
    return null;
  const s = [];
  return n.forEach((e) => {
    var a, o, c;
    let t = e.message;
    (a = e == null ? void 0 : e.extensions) != null && a.messages && (t += ": " + e.extensions.messages.join(", ")), ((o = e == null ? void 0 : e.extensions) == null ? void 0 : o.category) === "validation" && ((c = e == null ? void 0 : e.extensions) != null && c.validation) && (t += ": " + Object.values(e.extensions.validation).join(", ")), s.push(t);
  }), /* @__PURE__ */ i(u, { errors: s });
};
export {
  y as A,
  N as G,
  A as a,
  j as b
};
